export class Switch {
    private $input: JQuery;
    public onChange?: { (value: boolean) };

    constructor($input?: JQuery) {
        this.$input = $input === undefined ? $('<input data-switch="true" type="checkbox" />') : $input;
        this.$input.bootstrapSwitch({
            onSwitchChange: () => {
                if (this.onChange !== undefined) this.onChange(this.getValue());
            },
        });
    }

    public getValue(): boolean {
        return this.$input.bootstrapSwitch("state");
    }

    public setValue(value?: boolean): Switch {
        this.$input.bootstrapSwitch("state", value === undefined || value === false ? false : true);
        return this;
    }

    public setError(hasError: boolean): Switch {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean): Switch {
        this.$input.bootstrapSwitch("disabled", isDisabled);
        return this;
    }

    public renderTo($element: JQuery): Switch {
        this.$input.appendTo($element);
        return this;
    }
}
